import { useEffect, useState } from "react";
import { registerVisitor } from "../../services/visitorCounter";

function VisitorCounter() {
  const [counts, setCounts] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let isActive = true;

    registerVisitor()
      .then((nextCounts) => {
        if (isActive) {
          setCounts(nextCounts);
        }
      })
      .catch(() => {
        if (isActive) {
          setFailed(true);
        }
      });

    return () => {
      isActive = false;
    };
  }, []);

  if (failed) {
    return null;
  }

  if (!counts) {
    return (
      <div
        className="visitor-counter visitor-counter-loading"
        aria-label="방문자 수 불러오는 중"
      >
        <span className="visitor-dot" aria-hidden="true" />
        <span className="visitor-skeleton" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className="visitor-counter" aria-live="polite">
      <span className="visitor-dot" aria-hidden="true" />
      <span>
        오늘 <strong>{counts.today.toLocaleString("ko-KR")}</strong>명
      </span>
      <span className="visitor-divider" aria-hidden="true" />
      <span>
        토탈 <strong>{counts.total.toLocaleString("ko-KR")}</strong>명
      </span>
    </div>
  );
}

export default VisitorCounter;
